<template>
  <chat-history :messages="messages" :displayID="displayID" ref="chatHistory"></chat-history>
</template>

<script>

import ChatHistory from "./ChatHistory";
export default {
  name: "ChatHistoryPage",
  components: {ChatHistory},
  data() {
    return {
      messages: [],
      displayID: ""
    }
  },

  computed: {

  },

  mounted() {
    this.displayID = this.$route.query.displayID;
    this.timestamp = this.$route.query.timestamp;

    this.loadMessages();
  },

  methods: {
    loadMessages() {
      let url = `/api/chat_messages?displayID=${this.displayID}`;
      if (this.timestamp) {
        url += `&ts=${this.timestamp}&ts_since=60`;
      }

      this.$axios.get(url).then((res) => {
        const data = res.data;

        let addedMarker = false;

        for (let message of data.messages) {
          if (message.server_ts > parseInt(this.timestamp) && !addedMarker) {
            this.messages.push({
              "marker": true,
              "type": "marker"
            });
            addedMarker = true;
          }
          this.addMessage(this.messages, message);
        }

        setTimeout(() => {
          this.$refs.chatHistory.scrollToMarker();
        }, 250);
      }).catch((err) => {
        console.error(err);
      })
    },

    addMessage(messages, payload) {
      let msg = payload.data;
      let server_ts = payload.server_ts;
      let ts = new Date();
      if (server_ts) {
        ts = new Date(server_ts * 1000);
      }

      let read = Boolean(msg.read);
      messages.push({
        'type': payload.type || 'group',
        'ts': ts,
        'text': msg.text,
        'name': msg.displayName,
        'name_mentions': msg.name_mentions,

        // voice chat
        'filename': msg.filename,

        // gift chat
        'giftId': msg.giftId,
        'targetName': msg.targetName,
        'targetIsBot': msg.targetIsBot,

        // emoji chat
        'emojiId': msg.emojiId,

        'read': read,
        'result': msg.result || 0,
        'senderName': msg.sent_by ? msg.sent_by.user : null,
        'hand_num': payload.type === "handend" ? msg.hand_num || -1 : -1,
        'group': msg.group !== false,
        'senderId': msg.senderId,
        'senderType': msg.senderType,
        '_id': payload._id
      });
    },
  }
}
</script>

<style scoped>

</style>
